export const MAINTENANCE_FORCED_SESSION_KEY = 'owninn:maintenanceForced';
export const MAINTENANCE_RETURN_PATH_SESSION_KEY = 'owninn:maintenanceReturnPath';
export const MAINTENANCE_PATH = '/maintenance';
export const LOGIN_PATH = '/auth/login';
export const AUTH_PATH_PREFIX = '/auth/';
export const DEFAULT_MAINTENANCE_RETURN_PATH = '/';
export const HEALTH_CHECK_INTERVAL_MS = 30_000;
